import * as React from 'react'
import { InputClass } from '@sphinx/components-styles'
import * as classNames from 'classnames'

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean
}

const getClassName = (invalid: boolean) => {
  return invalid ? InputClass.invalid : InputClass.valid
}

function InputWithRef(
  { children, invalid, className, ...props }: InputProps,
  ref: React.Ref<HTMLInputElement>
) {
  return (
    <input
      className={classNames(getClassName(invalid), className)}
      ref={ref}
      {...props}
    >
      {children}
    </input>
  )
}

export const Input = React.forwardRef(InputWithRef)
